// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignedUpBusinesses_modal__B\\+Uxl {
  width: 40rem;
}
.SignedUpBusinesses_modal_title__qxYFj {
  width: 100%;
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 3rem;
  color: #4a4a68;
  margin: 5rem 0 4rem 0;
}
.SignedUpBusinesses_modal_section__AyO-o {
  display: flex;
  flex-direction: column;
  width: 38rem;
  gap: 1rem;
  margin-bottom: 2rem;
}
.SignedUpBusinesses_modal_section__key__iW5Up {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #1f68d6;
}
.SignedUpBusinesses_modal_section__value__ugR\\+\\+ {
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #4a4a68;
}

.SignedUpBusinesses_metrics__I1vDU {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin-bottom: 3rem;
}
@media only screen and (max-width: 37.5em) {
  .SignedUpBusinesses_metrics__I1vDU {
    grid-template-columns: repeat(2, 1fr);
  }
}

.SignedUpBusinesses_searchInMiddle__WzY6p {
  display: flex;
  justify-content: center;
  align-items: center;
}

.SignedUpBusinesses_filterClass__KeUdg {
  display: flex;
  justify-content: space-between;
  margin-top: 8rem;
}
@media only screen and (max-width: 25em) {
  .SignedUpBusinesses_filterClass__KeUdg {
    flex-direction: column;
  }
}

.SignedUpBusinesses_switch__xZayM {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 42rem;
  margin-top: 4rem;
  margin-bottom: 2rem;
  cursor: pointer;
}
.SignedUpBusinesses_switch__xZayM > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.SignedUpBusinesses_switch__show__CdheW {
  background-color: var(--color-dark);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.SignedUpBusinesses_switch__show_b__rIQMe {
  border: 1px solid var(--color-dark);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.SignedUpBusinesses_switch__hide__oXJvS {
  background-color: var(--color-dark);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.SignedUpBusinesses_switch__hide_b__ceoQ7 {
  border: 1px solid var(--color-dark);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SignedUpBusinesses/SignedUpBusinesses.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF;AAGE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAII;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFN;AAKI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAHN;;AAQA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AALF;AAOE;EANF;IAOI,qCAAA;EAJF;AACF;;AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAJF;AAME;EALF;IAMI,sBAAA;EAHF;AACF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAHF;AAKE;EACE,sBAAA;EACA,kBAAA;AAHJ;AAME;EACE,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAJJ;AAMI;EACE,mCAAA;EACA,4BAAA;EACA,oBAAA;AAJN;AAQE;EACE,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AANJ;AAQI;EACE,mCAAA;EACA,4BAAA;EACA,oBAAA;AANN","sourcesContent":["@import \"../variables/breakpoints\";\n\n.modal {\n  width: 40rem;\n\n  &_title {\n    width: 100%;\n    font-weight: 700;\n    font-size: 2.4rem;\n    line-height: 3rem;\n    color: #4a4a68;\n    margin: 5rem 0 4rem 0;\n  }\n\n  &_section {\n    display: flex;\n    flex-direction: column;\n    width: 38rem;\n    gap: 1rem;\n    margin-bottom: 2rem;\n\n    &__key {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 17px;\n      color: #1f68d6;\n    }\n\n    &__value {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 22px;\n      color: #4a4a68;\n    }\n  }\n}\n\n.metrics {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2rem;\n  margin-bottom: 3rem;\n\n  @media only screen and (max-width: $bp-600) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.searchInMiddle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filterClass {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8rem;\n\n  @media only screen and (max-width: $bp-400) {\n    flex-direction: column;\n  }\n}\n\n.switch {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  box-sizing: border-box;\n  font-size: var(--default-font-small);\n  width: 42rem;\n  margin-top: 4rem;\n  margin-bottom: 2rem;\n  cursor: pointer;\n\n  & > * {\n    padding: 1rem 0 1rem 0;\n    text-align: center;\n  }\n\n  &__show {\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    border-radius: 1rem 0 0 1rem;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-dark);\n      border-radius: 1rem 0 0 1rem;\n      transition: all 0.4s;\n    }\n  }\n\n  &__hide {\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    border-radius: 0 1rem 1rem 0;\n    transition: all 0.4s;\n\n    &_b {\n      border: 1px solid var(--color-dark);\n      border-radius: 0 1rem 1rem 0;\n      transition: all 0.4s;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `SignedUpBusinesses_modal__B+Uxl`,
	"modal_title": `SignedUpBusinesses_modal_title__qxYFj`,
	"modal_section": `SignedUpBusinesses_modal_section__AyO-o`,
	"modal_section__key": `SignedUpBusinesses_modal_section__key__iW5Up`,
	"modal_section__value": `SignedUpBusinesses_modal_section__value__ugR++`,
	"metrics": `SignedUpBusinesses_metrics__I1vDU`,
	"searchInMiddle": `SignedUpBusinesses_searchInMiddle__WzY6p`,
	"filterClass": `SignedUpBusinesses_filterClass__KeUdg`,
	"switch": `SignedUpBusinesses_switch__xZayM`,
	"switch__show": `SignedUpBusinesses_switch__show__CdheW`,
	"switch__show_b": `SignedUpBusinesses_switch__show_b__rIQMe`,
	"switch__hide": `SignedUpBusinesses_switch__hide__oXJvS`,
	"switch__hide_b": `SignedUpBusinesses_switch__hide_b__ceoQ7`
};
export default ___CSS_LOADER_EXPORT___;
